import React, { useState, useEffect } from 'react';
import {
    MaterialUiCore,
    // @ts-ignore
} from '@gscope-mfe/common-libs';
const { Typography, TextField, IconButton } = MaterialUiCore;
import SearchIcon from '@mui/icons-material/Search';
import classes from './DownloadFrameworkCss.module.css';
import DownloadFrameworkTable from './DownloadFrameworkTable';

const DownloadHistory = ({
    downloadHistory,
    showTableHead,
    startDownloadFile,
    formatTime,
    downloadingTransactionId,
}) => {
    const [filteredDownloadHistory, setFilteredDownloadHistory] = useState([]);
    const [searchKeyword, setSearchKeyword] = useState('');

    useEffect(() => {
        setFilteredDownloadHistory(downloadHistory);
    }, [downloadHistory]);

    const filterList = (value) => {
        setSearchKeyword(value);
        if (!value) {
            setFilteredDownloadHistory(downloadHistory);
            return;
        }
        const list = downloadHistory?.filter((item) => item?.fileName?.toLowerCase()?.includes(value?.toLowerCase()));
        setFilteredDownloadHistory(list);
    };

    return (
        <>
            <div className={classes.downloadHistoryContainer}>
                <Typography data-testid="details-title" variant="h6">
                    Details
                </Typography>
                <div className={classes.flexStart}>
                    <Typography data-testid="rows-count">{filteredDownloadHistory?.length} results</Typography>
                    <TextField
                        variant="outlined"
                        value={searchKeyword}
                        onChange={(e) => filterList(e.target.value)}
                        placeholder="Search..."
                        className={classes.searchBox}
                        InputProps={{
                            endAdornment: (
                                <IconButton data-testid="search-icon">
                                    <SearchIcon />
                                </IconButton>
                            ),
                        }}
                        inputProps={{ 'data-testid': 'Search' }}
                    ></TextField>
                </div>
            </div>
            <DownloadFrameworkTable
                showTableHead={showTableHead}
                filteredDownloadHistory={filteredDownloadHistory}
                startDownloadFile={startDownloadFile}
                formatTime={formatTime}
                downloadingTransactionId={downloadingTransactionId}
            />
            {filteredDownloadHistory && filteredDownloadHistory?.length > 0 && (
                <div data-testid="bottom-bar" className={classes.bottomBar}>
                    <div>
                        Showing <span className={classes.bold}>1</span> -{' '}
                        <span className={classes.bold}>{filteredDownloadHistory?.length}</span>
                    </div>
                </div>
            )}
        </>
    );
};

export default DownloadHistory;
